import { render, staticRenderFns } from "./home_topic.vue?vue&type=template&id=21c01649&scoped=true&"
import script from "./home_topic.vue?vue&type=script&lang=js&"
export * from "./home_topic.vue?vue&type=script&lang=js&"
import style0 from "./home_topic.vue?vue&type=style&index=0&id=21c01649&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c01649",
  null
  
)

export default component.exports